module.exports = __webpack_public_path__ + "img/fa-shop.8fbeaf3.svg";